import React, { FunctionComponent } from 'react'

import { format, getMonth, getYear, Locale, setMonth } from 'date-fns'

import { Box } from '@/atoms/layout'

import { StyledButton, StyledHeader, StyledSelect } from './styled-datepicker-header'

export interface DatepickerHeaderProps {
  date: Date
  prevMonthButtonDisabled: boolean
  nextMonthButtonDisabled: boolean
  prevYearButtonDisabled: boolean
  nextYearButtonDisabled: boolean
  changeYear: (year: number) => void
  changeMonth: (month: number) => void
  decreaseMonth: () => void
  increaseMonth: () => void
  decreaseYear: () => void
  increaseYear: () => void
}

interface Props {
  params: DatepickerHeaderProps
  locale: Locale
  maxDate?: Date
  minDate?: Date
}

const DatepickerHeader: FunctionComponent<Props> = ({ params, locale, minDate, maxDate }) => {
  const { date, decreaseMonth, prevMonthButtonDisabled, changeMonth, increaseMonth, nextMonthButtonDisabled, changeYear } = params
  const months = new Array(12).fill(null).map((_, i) => ({
    value: i,
    label: format(setMonth(new Date(), i), 'MMMM', { locale }),
  }))

  const years = Array.from({ length: getYear(maxDate) - getYear(minDate) + 1 }, (_, i) => getYear(maxDate) - i)

  const handleYearChange = ({ target: { value } }): void => changeYear(value)
  const handleMonthChange = ({ target: { value } }): void => changeMonth(value)

  return (
    <StyledHeader>
      <StyledButton onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button">
        {'<'}
      </StyledButton>

      <Box>
        <StyledSelect onChange={handleMonthChange} value={getMonth(date)}>
          {months.map(({ value, label }) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </StyledSelect>

        <StyledSelect onChange={handleYearChange} value={getYear(date)}>
          {years.map(year => (
            <option value={year} key={year}>
              {year}
            </option>
          ))}
        </StyledSelect>
      </Box>

      <StyledButton type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
        {'>'}
      </StyledButton>
    </StyledHeader>
  )
}

export default DatepickerHeader
